// import React, { useEffect } from "react";
// import styles from "./PrivacyPolicy.module.css";

// const PrivacyPolicy = () => {

//     return (
//         <div className={styles.container}>
//             <div className={styles.header}>
//                 <div>
//                     <h1>Privacy Policy</h1>
//                     <p className={styles.lastUpdated}>Last Updated: 18-March-2026</p>
//                 </div>
//             </div>

//             <div className={styles.content}>
//                 <p>
//                     Quiz Master ("we", "our", or "us") values your privacy. This Privacy
//                     Policy explains how we collect, use, store, and protect your
//                     information when you use the Quiz Master mobile application and
//                     related services.
//                 </p>

//                 <p>
//                     Quiz Master is a quiz-based entertainment and learning app that allows
//                     users to log in using their phone number and PIN, or access
//                     features through guest login.
//                 </p>

//                 <p>
//                     By using Quiz Master, you agree to the practices described in this
//                     Privacy Policy. If you do not agree, please do not use the app.
//                 </p>

//                 <h2>1. Information We Collect</h2>

//                 <h3>1.1 Information You Provide</h3>
//                 <ul>
//                     <li>
//                         <strong>Phone Number:</strong> We may collect your phone number to
//                         identify your account, allow login, and provide access to the app.
//                     </li>
//                     <li>
//                         <strong>PIN:</strong> We use your PIN as part of the login process
//                         to help secure your account.
//                     </li>
//                     {/* <li>
//                         <strong>Guest Login Information:</strong> If you use guest login, we
//                         may create a temporary or limited-access session without requiring
//                         full account registration.
//                     </li> */}
//                 </ul>

//                 <h3>1.2 Automatically Collected Information</h3>
//                 <ul>
//                     {/* <li>
//             <strong>Device Information:</strong> Such as device model, operating
//             system, app version, language, and unique device identifiers.
//           </li> */}
//                     <li>
//                         <strong>Usage Information:</strong> Such as quizzes played, scores,
//                         app interactions, game progress, session activity, and feature usage.
//                     </li>
//                     <li>
//                         <strong>Log Data:</strong> Such as app crash reports,
//                         performance logs, and diagnostic information.
//                     </li>
//                 </ul>

//                 <h2>2. How We Use Your Information</h2>
//                 <p>We may use your information for the following purposes:</p>
//                 <ul>
//                     <li>To allow login and access to the app.</li>
//                     <li>To manage and secure your account.</li>
//                     <li>To provide quiz gameplay, scores, and app features.</li>
//                     <li>To improve app performance and user experience.</li>
//                     <li>To troubleshoot technical issues and prevent misuse.</li>
//                     <li>To maintain service functionality and app security.</li>
//                 </ul>

//                 <h2>3. Guest Login</h2>
//                 <p>
//                     Quiz Master also allow users to access features through guest
//                     login.
//                 </p>

//                 <h2>4. Data Retention</h2>
//                 <p>
//                     We retain your information only for as long as necessary to provide
//                     the service, maintain app functionality, resolve disputes, enforce our
//                     terms, and comply with legal obligations.
//                 </p>

//                 <h2>5. Data Security</h2>
//                 <p>
//                     We take reasonable technical and organizational measures to protect
//                     your information from unauthorized access, misuse, loss, alteration,
//                     or disclosure. However, no method of electronic transmission or
//                     storage is completely secure.
//                 </p>

//                 <h2>6. Children’s Privacy</h2>
//                 <p>
//                     Quiz Master is not intended to knowingly collect personal information
//                     from children in violation of applicable law. If you believe that a
//                     child has provided personal information without proper consent, please
//                     contact us so we can take appropriate action.
//                 </p>

//                 {/* <h2>7. Your Rights and Choices</h2>
//                 <p>
//                     Depending on applicable law, you may have the right to request access
//                     to, correction of, or deletion of your personal information. You may
//                     also contact us if you want to ask questions about your data.
//                 </p> */}

//                 <h2>7. Changes to This Privacy Policy</h2>
//                 <p>
//                     We may update this Privacy Policy from time to time. Any changes will
//                     be posted in the app or on the relevant page with the updated date.
//                 </p>

//                 <h2>8. Contact Us</h2>
//                 <p>
//                     If you have any questions about this Privacy Policy, you may contact
//                     us at:
//                 </p>

//                 <p>
//                     <strong>App Name:</strong> Quiz Master
//                     <br />
//                     <strong>Email:</strong> sales@rainboosoftmate.com
//                     <br />
//                     <strong>Company:</strong> Rainboo Softmate Private Limited
//                 </p>
//             </div>
//         </div>
//     );
// };

// export default PrivacyPolicy;


import React from "react";
import styles from "./PrivacyPolicy.module.css";

const PrivacyPolicy = () => {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div>
          <h1>Privacy Policy</h1>
          <p className={styles.lastUpdated}>Last Updated: 18-March-2026</p>
        </div>
      </div>

      <div className={styles.content}>
        <p>
          Quiz Master ("we", "our", or "us") respects your privacy. This Privacy
          Policy explains how Quiz Master handles user privacy when using the app.
        </p>

        <p>
          Quiz Master is a trivia and quiz-based entertainment app. Users can
          access and play the trivia game using guest mode only.
        </p>

        <p>
          We do not collect, store, or share any personal information from users
          while they use the app in guest mode.
        </p>

        <p>
          By using Quiz Master, you agree to this Privacy Policy. If you do not
          agree, please do not use the app.
        </p>

        <h2>1. Information We Collect</h2>
        <p>
          We do not collect any personal information from users of Quiz Master.
        </p>

        <p>
          Users play the trivia game through guest mode, and no registration is
          required.
        </p>

        <h2>2. Guest Mode Usage</h2>
        <p>
          Quiz Master provides access through guest mode so users can play the
          trivia game without creating an account or submitting personal details.
        </p>

        <h2>3. Data Usage</h2>
        <p>
          Since we do not collect personal information, we do not use, sell,
          rent, or share user personal data.
        </p>

        <h2>4. Data Security</h2>
        <p>
          Although Quiz Master does not collect personal information, we take
          reasonable measures to maintain the security and proper functioning of
          the app.
        </p>

        <h2>5. Children’s Privacy</h2>
        <p>
          Quiz Master does not knowingly collect personal information from
          children or any other users.
        </p>

        <h2>6. Changes to This Privacy Policy</h2>
        <p>
          We may update this Privacy Policy from time to time. Any updates will
          be posted in the app or on the relevant page with the updated date.
        </p>

        <h2>7. Contact Us</h2>
        <p>
          If you have any questions about this Privacy Policy, you may contact
          us at:
        </p>

        <p>
          <strong>App Name:</strong> Quiz Master
          <br />
          <strong>Email:</strong> sales@rainboosoftmate.com
          <br />
          <strong>Company:</strong> Rainboo Softmate Private Limited
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;